import { Step1, Step2, Step3, Step4 } from '../assets/images';

export const steps = [
  {
    id: 1,
    title: 'Talk to our advisors',
    content:
      'Get in touch with us either by telephone or email after first learning as much as possible about CIP Turkey.',
    img: <Step1 />,
  },
  {
    id: 2,
    title: 'Complete investment',
    content:
      'We will send you a short questionnaire to assist us with learning more about your individual circumstances, then help you select the right path for you and your family.',
    img: <Step2 />,
  },
  {
    id: 3,
    title: 'Apply for citizenship',
    content:
      'After selecting and completing your preferred investment option, we will arrange for you to grant power of attorney to our lawyers so that we can start the application for your Turkish citizenship.',
    img: <Step3 />,
  },
  {
    id: 4,
    title: 'Receive Turkish Passport',
    content:
      'Within two months of applying, you and your family will become Turkish citizens.',
    img: <Step4 />,
  },
];
